<template>
  <div class="shareCode_container">
    <div class="bindBackground">
      <div class="codeBox">
        <div class="top">
          <div class="avatarUrl">
            <img mode="aspectFill" :src="employee.avatarUrl" class="image" />
          </div>
          <div class="employeeInfo_code">
            <!-- <span>邀请码：{{ employee.shareCode }}</span> -->
          </div>
        </div>
      </div>
    </div>
    <div class="shareHeader"></div>
    <div class="bindInput">
      <div class="shareInput1">
        <van-field
          v-if="userInfo.phoneNumber"
          placeholder="请输入手机号"
          :value="userInfo.phoneNumber"
          readonly
        />
        <van-field
          v-if="!userInfo.phoneNumber"
          v-model="submitInfo.phoneNumber"
          type="tel"
          maxlength="30"
          clearable
          placeholder="请输入手机号"
          @click="input"
        />
      </div>
      <div class="shareInput2" v-if="!userInfo.phoneNumber">
        <van-field
          label-width="20vw"
          v-model="submitInfo.code"
          clearable
          placeholder="请输入验证码"
          type="number"
          @input="changeauthCd"
        >
          <template #button>
            <!-- <van-button size="small" color="#FF9654" plain>发送验证码</van-button> -->
            <button
              slot="button"
              :disabled="!countdown"
              type="text"
              v-bind:class="[countdown ? 'reg_active' : 'reg_disActive']"
              @click="getCode"
            >
              <span v-if="countdown">{{ text }}</span>
              <span v-if="!countdown">{{ text }} ({{ count }})</span>
            </button>
          </template>
        </van-field>
      </div>
      <div class="buttonText">
        <button class="bindButton" @click="bindCheck()">绑定</button>
      </div>
      <div
        style="
          margin-top: 20px;
          font-size: 13px;
          color: #005ead;
          text-align: center;
          letter-spacing: 2px;
        "
        @click="GoHome"
      >
        立即前往购物
      </div>
    </div>

    <div class="footer"></div>
    <!-- onSubmit -->

    <shareCodeResult ref="IsCodeResult"></shareCodeResult>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import {
  Button,
  Image,
  Cell,
  CellGroup,
  Field,
  Notify,
  Toast,
  Dialog,
} from "vant";
import service from "../../api/employeePage/index";
import serviceCode from "../../api/setting/index.js";
import shareCodeResult from "../shareCodeResult/index.vue";
export default {
  components: {
    [Button.name]: Button,
    [Image.name]: Image,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Notify.name]: Notify,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    shareCodeResult,
  },
  data() {
    return {
      IsCodeResult: false, //绑定结果
      employee: {
        name: "",
        avatarUrl: "",
        shareCode: "",
      },
      submitInfo: {
        phoneNumber: "",
        code: "",
        shareCode: "",
      },
      countdown: true,
      count: "",
      timer: null,
      text: "发送验证码",
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  mounted() {
    this.scanCodeshareType = this.$route.query.shareType;
    console.log(this.scanCodeshareType, "this.scanCodeshareType");
    // "3958ELP4" this.$route.query.shareCode
    this.submitInfo.shareCode = this.$route.query.shareCode;
    this.employee.shareCode = this.$route.query.shareCode;
    // this.submitInfo.shareCode = "3958ELP4";
    // this.employee.shareCode = "3958ELP4";
    if (this.userInfo.phoneNumber) {
      this.submitInfo.phoneNumber = this.userInfo.phoneNumber;
    }
    if (
      this.userInfo.userType == "common" &&
      this.userInfo.statusName == "limited"
    ) {
      if (
        this.scanCodeshareType !== null &&
        this.scanCodeshareType !== undefined &&
        this.scanCodeshareType !== "" &&
        this.scanCodeshareType === true
      ) {
        console.log("scanCodeshareType绑定进入获取上级");
        this.getDataScan();
      } else {
        this.getData();
      }
    } else {
      this.$router.replace("page");
    }
    this.$refs.IsCodeResult.$el.style.display = "none";
  },
  methods: {
    init() {
      setTimeout(function () {
        var top = document.activeElement.getBoundingClientRect().top;
        window.scrollTo(0, top);
      }, 100);
    },
    // 验证码不能超过6位
    changeauthCd() {
      if (this.submitInfo.code.length > 6) {
        this.submitInfo.code = this.submitInfo.code.slice(0, 6);
        Toast("验证码不能超过6位");
      }
    },
    input() {
      this.init();
    },
    submit() {
      this.init();
    },
    GoHome() {
      // 1去登录
      this.$router.replace("page");
    },
    getCode() {
      // var reg = /^(1[0-9])\d{9}$/;
      var reg = /^(\d{8,30})$/;

      if (!reg.test(this.submitInfo.phoneNumber)) {
        Toast("请输入正确的电话号码");
        return;
      }
      console.log(this.submitInfo.phoneNumber, 188);
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.countdown = false;
        this.text = "重新发送";
        serviceCode
          .code({
            phoneNumber: this.submitInfo.phoneNumber,
            code: "",
          })
          .then((res) => {
            // this.$router.replace("page");
            if (res.statusCode == 200 && res.data == 1) {
              Toast("发送成功");
            }
          })
          .catch((err) => {});
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.countdown = true;

            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    getData() {
      // 绑定分享码
      service
        .getbyShareCode(this.employee.shareCode)
        .then((res) => {
          if (res.statusCode == 200) {
            this.employee.name = res.data.name;
            this.employee.avatarUrl = res.data.avatarUrl;
          } else {
            Toast("分享码已失效");
            // this.$router.replace('employeeCode')
          }
        })
        .catch((err) => {
          Toast("分享码已失效");
          // if(res.statusCode == 400){
          //   this.$router.replace('employeeCode')
          // }
        });
    },
    // 扫绑定用户码进入
    getDataScan() {
      service
        .userByShareCode(this.employee.shareCode)
        .then((res) => {
          if (res.statusCode == 200) {
            this.employee.name = res.data.name;
            this.employee.avatarUrl = res.data.avatarUrl;
          } else {
            Toast("分享码已失效");
            // this.$router.replace('employeeCode')
          }
        })
        .catch((err) => {
          Toast("分享码已失效");
          // if(res.statusCode == 400){
          //   this.$router.replace('employeeCode')
          // }
        });
    },
    // 点击绑定 弹窗 弹出 点击确定 调取接口
    bindCheck() {
      Dialog.confirm({
        message: "绑定成功后需重新进入商城，确认绑定吗？",
      })
        .then(() => {
          if (
            this.scanCodeshareType !== null &&
            this.scanCodeshareType !== undefined &&
            this.scanCodeshareType !== "" &&
            this.scanCodeshareType === true
          ) {
            console.log("scanCodeshareType绑定进入");
            this.scanCodeSubmit();
          } else {
            this.onSubmit();
          }
        })
        .catch(() => {
          // on cancel
        });
    },
    // 扫绑定用户进入页面的绑定
    scanCodeSubmit() {
      // var phoneReg = /^(1[0-9])\d{9}$/;
      var phoneReg = /^(\d{8,30})$/;
      if (!phoneReg.test(this.submitInfo.phoneNumber)) {
        // Notify({ type: "danger", message: "手机号格式不正确" });
        Toast("手机号格式不正确");
        return;
      }

      // 如果绑定过手机号
      if (this.userInfo.phoneNumber) {
        service
          .bindShareCodeForUser({
            shareCode: this.submitInfo.shareCode,
          })
          .then((res) => {
            if (res.statusCode == 200) {
              Toast("绑定成功");
              this.$refs.IsCodeResult.$el.style.display = "block";
              // setTimeout(() => {
              //   this.$router.replace({
              //     name: "user",
              //     params: {
              //       IsCode: true
              //     }
              //   });
              // }, 1000);
            } else {
              Toast(res.errors);
              this.$router.replace({
                name: "bindStatus",
                query: { status: false },
              });
            }
          })
          .catch((err) => {
            Toast(err);
            this.$router.replace({
              name: "bindStatus",
              query: { status: false },
            });
          });
      } else {
        if (this.submitInfo.code == "") {
          Toast("验证码不能为空");
          return;
        }
        service
          .bindPhoneNumberAndShareCodeForUser({
            phoneNumber: this.submitInfo.phoneNumber,
            smsCode: this.submitInfo.code,
            shareCode: this.submitInfo.shareCode,
          })
          .then((res) => {
            if (res.statusCode == 200) {
              Toast("绑定成功");
              this.$refs.IsCodeResult.$el.style.display = "block";
              // setTimeout(() => {
              //   this.$router.replace({
              //     name: "user",
              //     params: {
              //       IsCode: true
              //     }
              //   });
              // }, 500);
            } else {
              Toast(res.errors);
              this.$router.replace({
                name: "bindStatus",
                query: { status: false },
              });
            }
          })
          .catch((err) => {
            Toast(err);
            this.$router.replace({
              name: "bindStatus",
              query: { status: false },
            });
          });
      }
    },
    onSubmit() {
      // var phoneReg = /^(1[0-9])\d{9}$/;
      var phoneReg = /^(\d{8,30})$/;
      if (!phoneReg.test(this.submitInfo.phoneNumber)) {
        // Notify({ type: "danger", message: "手机号格式不正确" });
        Toast("手机号格式不正确");
        return;
      }

      // 如果绑定过手机号
      if (this.userInfo.phoneNumber) {
        service
          .addNewUser({
            shareCode: this.submitInfo.shareCode,
          })
          .then((res) => {
            if (res.statusCode == 200) {
              Toast("绑定成功");
              this.$refs.IsCodeResult.$el.style.display = "block";
              // setTimeout(() => {
              //   this.$router.replace({
              //     name: "user",
              //     params: {
              //       IsCode: true
              //     }
              //   });
              // }, 1000);
            } else {
              Toast(res.errors);
              this.$router.replace({
                name: "bindStatus",
                query: { status: false },
              });
            }
          })
          .catch((err) => {
            Toast(err);
            this.$router.replace({
              name: "bindStatus",
              query: { status: false },
            });
          });
      } else {
        if (this.submitInfo.code == "") {
          Toast("验证码不能为空");
          return;
        }
        service
          .bindUser({
            phoneNumber: this.submitInfo.phoneNumber,
            smsCode: this.submitInfo.code,
            shareCode: this.submitInfo.shareCode,
          })
          .then((res) => {
            if (res.statusCode == 200) {
              Toast("绑定成功");
              this.$refs.IsCodeResult.$el.style.display = "block";
              // setTimeout(() => {
              //   this.$router.replace({
              //     name: "user",
              //     params: {
              //       IsCode: true
              //     }
              //   });
              // }, 500);
            } else {
              Toast(res.errors);
              this.$router.replace({
                name: "bindStatus",
                query: { status: false },
              });
            }
          })
          .catch((err) => {
            Toast(err);
            this.$router.replace({
              name: "bindStatus",
              query: { status: false },
            });
          });
      }
    },
  },
};
</script>
<style lang="less">
.shareCode_container {
  min-height: 100vh;
  background: linear-gradient(to bottom, #ffffff, #b0e1fa);
  // .input_center {
  //   border-radius: 7.73333vw;
  //   text-align: center;
  //   width: 54.4vw;
  //   border: 0;
  // }
  .flex {
    padding: 0 6.6vw;
    border-bottom: 1px solid #e6e6e6;
  }

  .van-cell {
    width: 60vw;
    font-size: 4vw;
    padding: 1vw 2vw;
    margin: 0 0 0 14vw;
    background: initial;
    // line-height: 30px;
    // height: 30px;
    .van-field__body {
      color: #9d9d9d;
      font-size: 4vw;
    }

    .van-field__control {
      color: #000;
    }
    .van-field__value {
      line-height: 10vw;
      height: 10vw;
    }
  }

  .group {
    padding: 33px 38px 0;
  }

  .bindBackground {
    background-image: url(../../../assets/images/bindHeader.png);
    height: 236px;
    background-repeat: no-repeat;
    // background-size: 100vw 354px;
    background-size: cover;
    background-position: center;
    position: relative;
    top: 0;
  }

  .top {
    position: absolute;
    z-index: 1;
    bottom: 21px;
    left: 50%;
    margin-left: -10vw;
    .title {
      font-size: 21px;
      color: #fffefe;
    }
  }

  .employeeInfo_code {
    font-size: 15px;
    color: #fffefe;
    display: flex;
    align-items: center;
  }
  .shareHeader {
    background-image: url(../../../assets/images/bindTitle.png);
    height: 86px;
    background-repeat: no-repeat;
    // background-size: 100vw 354px;
    background-size: cover;
    background-position: center;
    position: relative;
    top: 2vw;
  }
  .shareInput1 {
    background-image: url(../../../assets/images/bingInput1.png);
    height: 43.6px;
    width: 296px;
    background-repeat: no-repeat;
    // background-size: 100vw 354px;
    background-size: cover;
    background-position: center;
    position: relative;
    top: 0;
    margin-top: 12px;
  }
  .shareInput2 {
    background-image: url(../../../assets/images/bingInput2.png);
    height: 43.6px;
    width: 296px;
    background-repeat: no-repeat;
    // background-size: 100vw 354px;
    background-size: cover;
    background-position: center;
    position: relative;
    top: 0;
    margin-top: 12px;
  }
  .bindInput {
    position: fixed;
    z-index: 2;
    left: 50%;
    margin-left: -39.5vw;
    top: 50%;
    margin-top: 10px;
  }
  .footer {
    background-image: url(../../../assets/images/bindFooter.png);
    height: 133px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    position: fixed;
    bottom: 0;
    z-index: 1;
    width: 100%;
  }
  .avatarUrl {
    width: 75px;
    height: 75px;
    border-radius: 50%;

    .image {
      // width: 98px;
      // height: 98px;
      border-radius: 50%;
      // border: 1vw solid #ffcdd6;
    }
  }

  .reg_active {
    width: 20vw;
    background: #fff;
    color: #005ead;
    border: none;
    font-size: 3vw;
    padding: 0;
    height: 28px;
    line-height: 28px;
  }

  .reg_disActive {
    width: 26.8vw;
    background: #fff;
    color: #005ead;
    border: none;
    font-size: 2.4vw;
    height: 28px;
    line-height: 28px;
  }

  .buttonText {
    margin-top: 24px;
  }

  .buttonText .bindButton {
    border: 0;
    color: #fff;
    width: 62vw;
    height: 45px;
    font-size: 18px;
    border-radius: 43px;
    background: linear-gradient(to bottom, #00c0fa, #015eea);
  }

  // }
}
</style>
